import Controller from "./IHMozufuruArtifactController";
import Request from "../Request";
import numOfKofun from '../data/mozu-furu-artifact_kofun_number'
import kofunData from '../data/mozu-furu-artifact_kofun_data'
import museumData from '../data/mozu-furu-artifact_museum_data'

/**
 * 出土品検索ツール用
 *
 * メンテナンス
 * ?update=true: 古墳数・アイコンパスをconsole.log()で出力
 *
 * @type {IHMozuFuruArtifact}
 */
module.exports = class IHMozuFuruArtifact extends IH {
  constructor(options) {
    super(options);
    this.options = options;
    this.repositoryOptions = {
      type: 'facet',
      placeTypeFacetName: '出土品種別',
      searchApi: 'search',
      mappingItems: {
        lat: '緯度',
        lng: '経度',
        image: 'image_file',
        image_label: 'image_label',
        name: '名称',
        address: '',
        description: '',
        info: 'info'
      },
      sortTarget: {
        mound: '出土古墳の墳丘長',
        era: '出土古墳の築造時期'
      },
      sortValue: {
        eras: {
          '4世紀前葉': 1,
          '4世紀前半': 2,
          '4世紀中葉': 3,
          '4世紀後半': 4,
          '4世紀後葉': 5,
          '5世紀前葉': 6,
          '5世紀前半': 7,
          '5世紀中葉': 8,
          '5世紀後半': 9,
          '5世紀後葉': 10,
          '6世紀前葉': 11,
          '6世紀前半': 12,
          '6世紀中葉': 13,
          '6世紀後半': 14,
          '6世紀後葉': 15,
          '不明': 9999,
        }
      },
      firstSelection: '形象埴輪'
    };
    this.defaultSortKey = 'era';
    this.defaultSortOrder = 1;
    this.sortKey_1 = 'era';
    this.sortOrder_1 = 1;
    this.sortKey_2 = 'mound';
    this.sortOrder_2 = -1;
    this.detailMenus = ['名称', 'よみがな', '出土品種別', '様態', '備考', '展示施設', '所蔵・保管', '出土地域', '出土古墳', '古墳現状', '出土古墳の墳形', '出土古墳の築造時期', '出土古墳の墳丘長'];
    this.searchTargetTypes = [];
    this.show_direction_on_marker_click = false;
    this.defaultView = 'tile';
  
    /**
     * GoogleMap マップタイプ・マップコントロール設定
     */
    if (this.mapOptions.type === 'googlemap') {
      const gmap_options = {
        mapTypeId: google.maps.MapTypeId.TERRAIN,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM,
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          mapTypeIds: ['terrain', 'satellite']
        },
        streetViewControlOptions: {position: google.maps.ControlPosition.RIGHT_TOP},
        zoomControlOptions: {position: google.maps.ControlPosition.TOP_LEFT}
      };
      $.extend(true, this.mapOptions.gmap_options, gmap_options)
    }
    
    /**
     * 出土品検索アプリ固有変数
     */
    // 初期化(firstAction)完了管理
    this.isInitEnd = false;
    // 全検索解除実行モード管理
    this.isAllSelectionCleared = false;
    // 主墳検索モード管理
    this.isMasterServantSearchMode = false;
    // 表示済展示施設マーカー管理
    this.displayedMuseumMarkers = [];
    // 作成済展示施設オブジェクト管理
    this.createdMuseumPlaces = [];
    
    // 出土品種別ファセット値、出土古墳ファセット値の並び順
    this.artifactOrder = {};
    this.kofunOrder = {};
  
    // デフォルトで閉じておくファセット
    this.collapsedFacets = ['様態', '展示施設', '所蔵・保管', '出土古墳'];
    this.collapsedFacetIds = [];
    
    // 特集パネル古墳検索用の古墳数
    this.numberOfKofun = numOfKofun;
    this.kofunData = kofunData;
  
    // 主墳・陪塚検索時専用のfitBoundsを行うための情報(主墳の名称と緯度経度)
    this.masterKofunAttributes = {};
    this.filledMasterKofunAttributes = false;
    
    // 地図ビュー切替え時の地図中心位置
    this.defaultMapCenter = {
      lat: 34.581911,
      lng: 135.549748
    }

    this.iconNameMapping = {
      '前方後円墳': 'keyhole',
      '帆立貝形墳': 'scallop',
      '円墳': 'round',
      '方墳': 'square',
      '世界遺産': 'world-heritage',
      '現存': 'existing',
      '消滅': 'disappearance'
    }
  }
  
  createController(options) {
    return new Controller(options);
  }
  
  reset() {
    super.reset();
    this.init();
  }
  
  init() {
    // デフォルトで閉じておくファセットのID取得
    this.repository.getFacets().then(facets => {
      this.collapsedFacets.forEach((value, index) => {
        this.collapsedFacetIds[index] = _.find(facets, {name: value} ).id;
      });
    });
    
    // 出土品種別ファセット値、出土古墳ファセット値の並び順を取得
    $(this).on('ihRenderedSearchMenu', () => {
      this.repository.getFacets().then(facets => {
        const artifactFacetid = _.find(facets, {name: '出土品種別'} ).id;
        const kofunFacetid = _.find(facets, {name: '出土古墳'} ).id;
        const artifactFacetValues = $(`.js-tooltip[data-facet-id="${artifactFacetid}"]`);
        const kofunFacetValues = $(`.js-tooltip[data-facet-id="${kofunFacetid}"]`);
        $.each(artifactFacetValues, (i, facetValue) => {
          const facetValueName = $(facetValue).find('.js-facet-count').siblings().text();
          this.artifactOrder[facetValueName] = i;
        });
        $.each(kofunFacetValues, (i, facetValue) => {
          let facetValueName = $(facetValue).find('.js-facet-count').siblings().text().replace(/（.*）/, '');
          this.kofunOrder[facetValueName] = i;
        });
      });
    });

    $(this).on('ready', () => {
      this.setGoogleAnalytics();
      
      // 地形図表示
      this.controlTerrainMapLayers();
      
      // 主墳・陪塚検索メニューの描画・検索処理
      this.renderMasterServantSearchMenu();
      
      this.controlCollapsibleFacets();
      
      this.changeViewPortByFooterMenuSelection();

      // 種類で検索・名前で検索は必ず一方が開いた状態とする
      $('.ih-search-menu').on('collapse', function () { 
        const $otherSearchMenu = $(this).parent().siblings('.ui-collapsible-set').find('.ih-search-menu');
        if ($otherSearchMenu.hasClass('ui-collapsible-collapsed')) {
          $otherSearchMenu.trigger('expand');
        }
      });
      $('.ih-search-menu').on('expand', function () { 
        const $otherSearchMenu = $(this).parent().siblings('.ui-collapsible-set').find('.ih-search-menu');
        if (!$otherSearchMenu.hasClass('ui-collapsible-collapsed')) {
          $otherSearchMenu.trigger('collapse');
        }
      });
      
      $(this).on('ihAfterTransformPlacesResponse', (event, request, artifacts) => {
        this.fit_bounds = false;
        _.forEach(artifacts, artifact => {
          if (!this.isMasterServantSearchMode) {
            this.enableFitBounds(artifact);
          }
          this.setMarkerImage(artifact);
        });
      });
  
      // ズームレベルによってマーカーラベルの表示・非表示を切り替える（ラベルは出土古墳名）
      let labelingZoomLevel = 14;
      let labelStyle = {
        color: "#493E26",
        fontSize: "14px",
        fontWeight: '400',
        fontFamily: 'ヒラギノ丸ゴ Pro W4,ヒラギノ丸ゴ Pro,Hiragino Maru Gothic Pro,ヒラギノ角ゴ Pro W3,' +
          'Hiragino Kaku Gothic Pro,HG丸ｺﾞｼｯｸM-PRO,HGMaruGothicMPRO',
        text: ''
      };
      $(this.map).on('ihDisplayedOneMarker', (event, places, place, marker, popup) => {
        // 展示施設マーカー作成・描画
        this.createMuseumMarker(place, marker);

        const name = this.getKofunFacetValue(place);
        if (this.mapOptions.type === 'googlemap') {
          marker.name = name;
        } else if (this.mapOptions.type === 'openlayer') {
          marker.setProperties({name: name});
        }
        if (this.isMasterServantSearchMode) {
          if (!this.filledMasterKofunAttributes) {
            if (this.masterKofunAttributes.name === name) {
              this.masterKofunAttributes.lat = place.attributes['緯度'];
              this.masterKofunAttributes.lng = place.attributes['経度'];
              this.filledMasterKofunAttributes = true;
            }
          }
        }
      });
      $(this.map).on('ihDisplayedAllMarkers', (event, places, marker, popup) => {
        // this.showMarkerLabelByZoomLevel(labelingZoomLevel, labelStyle);
        this.displayedMuseumMarkers = [];
        if (this.isMasterServantSearchMode) {
          this.fitBoundsToMasterServantKofuns();
          this.filledMasterKofunAttributes = false;
        }
      });
      
      $(this).on('ihChangeZoom', (event, zoom) => {
        // this.showMarkerLabelByZoomLevel(labelingZoomLevel, labelStyle);
        const place = $('.info-window').data('place');
        if (place) {
          const latlng = this.map.createLatLng(place.lat, place.lng);
          setTimeout(() => this.map.setCenter(latlng), 0)
        }
      });
      
      // 詳細パネルとマーカーポップアップの内容の書き換え
      $(this).on('ihFillMarkerPopup', (event, place, popup) => {
        // マーカーポップアップ表示判定値を出土古墳名に変更
        // 同じ出土古墳の位置に複数の出土品マーカーを重ねて1つの古墳マーカーに見せかけているため、IDが複数存在し、表示判定ができない
        $(popup).data('place-id', place.attributes['出土古墳']);
        $(popup).data('place', place);
        $(popup).data('type', 'kofun');

        // 詳細パネル: アプリ固有の項目を作成する
        this.createDetailMenus(place, popup);
        
        // 詳細パネル: 画像ポップアップを作成する
        this.createImagePopup(place, popup);
  
        const iwName = this.getKofunFacetValue(place);
        const iwDesc = '墳丘長 ' + place.attributes['出土古墳の墳丘長'] + ', ' + place.attributes['出土古墳の築造時期'];
        if (popup.attr('class') === 'info-window') {
          popup.find('.iw-name').text(iwName);
        }
        popup.find('.iw-desc').text(iwDesc);
      });
      
      $(this).on('ihFillSearchResult', (event, place, item) => {
        const $srInfo = item.find('.sr-info');
        let kofun = this.getKofunFacetValue(place);
        let text = kofun + '（' + place.attributes['出土古墳の墳丘長'] + '）';
        $srInfo.text(text);
        item.find('.sr-img').prependTo($srInfo);
        item.find('.sr-type').hide();
      });
    });
  }
  
  /**
   *
   * @override
   * @protected
   */
  beforeStart() {
    return this.initFacets();
  }
  
  /**
   * ファセット一覧を取得して施設タイプを設定する
   *
   * @returns {*}
   */
  initFacets() {
    return this.repository.loadFacets().then(() => {
      this.setOptionsForPlaceTypes(this.repository.getPlaceTypes());
    });
  }
  
  /**
   *
   * @override
   */
  clickMarkerHandler(event, place, marker, popup) {
    if (this.map.forceMarkerOpen) {
      this.openInfoPanel(place);
    }
    this.map.toggleMarkerPopup(marker, popup);
    this.searchBySelectedMarker(place, marker, popup);
  }
  
  /**
   * 詳細パネル: アプリ固有の項目を作成する
   *
   * @param place
   * @param popup
   */
  createDetailMenus(place, popup){
    for (let i = 0, len = this.detailMenus.length; i < len; i++ ) {
      const td = popup.find('.iw-facet-' + (i+1));
      let attr = this.detailMenus[i];
      let text = '';
      
      // 施設オブジェクトに項目名と同じプロパティがあり、プロパティ値が空で無ければ項目の内容として表示
      if (attr in place.attributes && place.attributes[attr] !== '') {
        text = place.attributes[attr];

        // 属性名のうち「出土古墳の」を非表示
        attr = attr.replace('出土古墳の', '')

        // 展示施設名に施設アイコンを表示
        // 施設名が「その他」の場合は非表示
        const textOrigin = text;
        if (attr === '展示施設') {
          if (text === 'その他（非公開含む）') {
            td.closest('.iw-item').hide();
            continue;
          } else {
            const icon = `<img class="mf-af-detail-museum-icon" src="../sites/mozu-furu-artifact/assets/img/pin/museum_min.png" />`;
            text = `${icon}<a href="#" class="mf-af-detail-museum-name">${text}</a>`;
          }
        }
        
        // 出土古墳に古墳アイコンと別名を表示
        if (attr === '出土古墳') {
          let name = text.split(/\s>\s/)[1];
          const subName = place.attributes['名称2'];
          if (subName !== '') {
            name = name + subName;
          }
          const icon = `<img class="iw-type-icon mf-af-detail-kofun-icon" src="${place.icon_min}" />`;
          text = `${icon}<a href="#" class="mf-af-detail-kofun-name">${name}</a>`;
        }
        
        // 出土地域名の後に出土エリアを表示
        if (attr === '出土地域') {
          const area = text.split(/\s>\s/)[0];
          const city = text.split(/\s>\s/)[1];
          text = `${city}〔${area}〕`;
        }

        // 墳形に墳丘長も表示
        if (attr === '墳形') {
          text = `${text}〔墳丘長: ${place.attributes['出土古墳の墳丘長']}〕`;
        }
        
        td.html(text);

        // 展示施設名を選択すると地図ビューに切り替え、ポップアップを表示する
        if (attr === '展示施設' && textOrigin !== 'その他（非公開含む）') {
          td.find('.mf-af-detail-museum-name').on('click', () => {
            this.openMuseumMarkerPopup (place, textOrigin);
            this.forceChangeViewport('map');
          });
        }

        // 出土古墳名を選択すると地図ビューに切り替える
        if (attr === '出土古墳') {
          td.find('.mf-af-detail-kofun-name').on('click', () => {
            const marker = this.map.getPlaceMarker(place.id);
            this.openKofunMarkerPopup (place, marker);
            this.forceChangeViewport('map');
          });
        }

        td.closest('.iw-item').find('.iw-label').text(attr);
        td.closest('.iw-item').show();
      } else {
        td.closest('.iw-item').hide();
      }
    }
  }
  
  /**
   * 詳細パネル: 画像スライダー付きポップアップウィンドウを作成する
   *
   * @param place
   * @param popup
   */
  createImagePopup(place, popup){
    let credit = [];
    if ( place.image && popup.find('.iw-image-popup').length ){
      let imagePaths = place.image.split('|');                   // 画像パス ( 複数指定の場合、区切り文字は '|' )
      let imageTitle = place.attributes['名称'];                 // 画像名称（出土品名）
      let numOfImages = imagePaths.length;                       // 画像枚数
      credit = place.image_label.split('|');            // 写真提供元
      
      // 画像パス・写真提供元を整形
      for(let i = 0; i < numOfImages; i++) {
        // 改行や空白を削除
        imagePaths[i] = imagePaths[i].replace(/[\n\r\s]/g, '');
        credit[i] = credit[i].replace(/[\n\r\s]/g, '');
        
        // 画像パスがURLでなければ、ローカルパスを追加
        if (!imagePaths[i].match(/^http/)) {
          imagePaths[i] = this.place_image_path + imagePaths[i];
        }
      }
      
      // 画像枚数が2枚以上なら、ポップアップボタンの下に枚数表示
      if(numOfImages > 1){
        $('.iw-image-count').each(function () {
          $(this).text(numOfImages + '枚');
        });
      } else {
        $('.iw-image-count').each(function () {
          $(this).text('');
        });
      }
      
      popup.find('.iw-image-popup').show();
      let imagePopupContainer = popup.find('.iw-image-popup .iw-label');
      let imagePopup = $('#image-popup');
      
      // 画像ポップアップウィンドウとスライダの作成
      if ( imagePopup.length === 0 ){
        imagePopup = $('<div id="image-popup" data-role="popup" data-overlay-theme="a" data-theme="d" data-corners="false"></div>').appendTo( imagePopupContainer );
        //var imagePopupClose = $('<a href="#" data-rel="back" data-role="button" data-theme="a" class="ui-btn-right ui-btn ui-shadow ui-btn-corner-all ui-btn-icon-notext ui-btn-up-a"><span class="ui-btn-inner"><span class="ui-btn-text">Close</span><span class="ui-icon ui-icon-delete ui-icon-shadow">&nbsp;</span></span></a>').appendTo( imagePopup);
        //var img = $('<img>').appendTo( imagePopup );
        
        imagePopup.popup();
        
        // ポップアップを閉じるボタンを追加
        let closer = $('<button id="image-popup-closer" data-theme="b" class="ui-btn ui-corner-all ui-shadow ui-btn-inline ui-btn-up-b">閉じる</button>');
        closer.appendTo(imagePopup);
        closer.on('click', function () {
          imagePopup.popup('close');
        });
        
        // ポップアップを閉じるボタンのデザイン
        // ここで設定しないとデザインが反映されない
        closer.css({
          'padding': '5px 12px',
          'font-size': '1em'
        });
      }
      
      $('#image-slider').remove();
      $('.bx-wrapper').remove();
      
      // スライダー用のdiv要素を作成し、ポップアップウィンドウに追加
      let imageSlider = $('<div id="image-slider"></div>');
      imageSlider.appendTo(imagePopup);
      
      // img要素を作成し、スライダー用divに追加
      for(let i = 0; i < numOfImages; i++) {
        // 画像は1枚目のみ読み込み、他はスライド直前に読み込み（遅延ロード）
        // 遅延ロードさせないと、ポップアップウィンドウ表示時に画像が一瞬縦に並んでしまう
        if (i === 0) {
          $('<div class="sliding-images"><img src="' + imagePaths[i] + '" title="' + imageTitle + '" id="sliding-image-' + i + '"></div>').appendTo(imageSlider);
        } else {
          $('<div class="sliding-images"><img title="' + imageTitle + '" id="sliding-image-' + i + '"></div>').appendTo(imageSlider);
        }
      }
      
      // ポップアップウィンドウの表示完了後にスライダを作成
      // これまでスライド作成できない不具合があったのは、恐らくポップアップ表示完了前にスライダが生成されいたため
      imagePopup.on( "popupafteropen", ( event, ui )=> {
        imageSlider.bxSlider({
          minSlides: 1,
          maxSlides: 1,
          slideMargin: 5,
          infiniteLoop: false,
          hideControlOnEnd: true,
          captions: true,
          // 画像遅延ロード
          onSlideBefore: function($slideElement, oldIndex, newIndex){
            $('#sliding-image-' + newIndex).attr('src', imagePaths[newIndex]);
            $('.mf-carousel-credit').remove();
            if (credit[newIndex] !== 'none') {
              $('.bx-caption span').append('<span class="mf-carousel-credit">' + credit[newIndex] + '</span>');
            }
          },
          onSliderLoad: function (currentIndex) {
            $('.mf-carousel-credit').remove();
            if (credit[0].indexOf('none') === -1) {
              $('.bx-caption span').append('<span class="mf-carousel-credit">' + credit[0] + '</span>');
            }
            // スライダーロード時にポップアップが左にずれることがあるため left 値を調整
            const popup = $('#image-popup-popup')
            const popupWidth = popup.width();
            const appWidth = $('#home').width();
            const popupSideMargin = (appWidth - popupWidth) / 2;
            popup.css('left', popupSideMargin);

            // 画像の高さ指定（CSSで指定していると、画面サイズによっては縦横比が乱れることがあるため）
            $('.bx-wrapper .sliding-images img').css('max-height', '95%');
          }
        });
      });
    }else{
      popup.find('.iw-image-popup').hide();
    }
    
    if (place.image_label && popup.find('.iw-image-label').length){
      popup.find('.iw-image-label-item').show();
      popup.find('.iw-image-label').text(credit[0]);
    }else{
      popup.find('.iw-image-label-item').hide();
    }
  }
  
  /**
   * @override
   * @returns {Array}
   */
  getSearchTargetTypes(){
    let types = [];
    for (let i in this.searchTargetTypes){
      if (this.searchTargetTypes[i]){
        types.push(i);
      }
    }
    return types;
  }
  
  /**
   * 出土品オブジェクトの"出土古墳"属性から古墳名を取得する
   * ( "(百舌鳥|古市)エリア > {古墳名}" 形式の表記から {古墳名} のみ切り出す )
   *
   * @param {Object} place
   * @returns {String}
   */
  getKofunFacetValue (place) {
    return place.attributes['出土古墳'].replace(/^(百舌鳥|古市)エリア\s>\s/, '');
  }
  
  changeViewPortByFooterMenuSelection () {
    // 検索パネル選択時にビューポートが地図になっている場合は写真一覧に切り替え
    $('.ih-footer-menu-search').on('click', () => {
      if (this.isMapViewDisplayed()){
        this.forceChangeViewport('tile');
      }
    });
    // 特集パネル選択時にビューポートが写真一覧になっている場合は地図に切り替え、中心位置を調整
    $('.mf-footer-menu-feature').on('click', () => {
      if (!this.isMapViewDisplayed()){
        this.forceChangeViewport('map');
      }
    });
  }
  
  controlTerrainMapLayers () {
    // 地形図表示時にヘッダーにセットするアプリ名
    const $header = $('#header h1.ui-title');
    const defaultTitle = this.options.title;
    const terrainMapTitle = this.options.title + '（古墳時代地形図）';
  
    // 地形図の表示座標
    const terrainMapBounds = {
      north: 34.8962,
      south: 34.4518,
      east: 135.7214,
      west: 135.3416
    };
    
    // 古墳時代地形図レイヤー作成
    const mapLayer = this.map.createStaticImageLayer(
      this.place_image_path + '../../maps/3.jpg',
      terrainMapBounds,
      0.65
    );
    
    $('.mf-map-selector').on('change', () => {
      const checked = $('.mf-kofun-era-terrain-map').prop('checked');
      if (checked) {
        $header.text(terrainMapTitle);
        // 地形図表示
        this.map.addLayer(mapLayer);
        // 地形図の中心位置を調整
        const center = this.map.createLatLng(this.defaultMapCenter.lat, this.defaultMapCenter.lng);
        this.map.setCenter(center);
        // ビューポートが写真一覧の場合は地図に切り替え
        // ビューポートが地図の場合はズームを調整
        if (!this.isMapViewDisplayed()){
          this.forceChangeViewport('map');
        } else {
          this.map.setZoom(this.defaultZoom)
        }
      } else {
        $header.text(defaultTitle);
        this.map.removeLayer(mapLayer);
      }
    });
  }
  
  /**
   * ビューポートの表示が地図かどうか
   *
   * @returns {Boolean}
   */
  isMapViewDisplayed () {
    const $mapViewDisplayer = $('.hz-map-view-button');
    return $mapViewDisplayer.prop('checked');
  }
  
  /**
   * ビューポート強制切り替え
   *
   * @param {String} view - map|tile
   */
  forceChangeViewport (view) {
    $('.hz-view-change-button-group input').val([view]).checkboxradio("refresh");
    if (view === 'map' && !$('#gmap').is(':visible')) {
      this.showMapView();
    } else if (view === 'tile')  {
      this.showTileView();
    }
  }
  
  /**
   * 出土古墳種別にもとづくマーカー画像設定
   *
   * @param {Object} artifact
   */
  setMarkerImage (artifact) {
    const length = parseInt(artifact.attributes['出土古墳の墳丘長'].replace(/m/, ''), 10);
    const shape = artifact.attributes['出土古墳の墳形'];
    if (artifact.attributes['古墳現状'] === '世界遺産') {
      artifact.icon_min = `${this.icon_file_path}${this.iconNameMapping[shape]}-wh_min.png`;
      artifact.icon_pin = `${this.icon_file_path}${this.iconNameMapping[shape]}-wh_pin.png`;
    } else if (artifact.attributes['古墳現状'] === '現存') {
      artifact.icon_min = `${this.icon_file_path}${this.iconNameMapping[shape]}_min.png`;
      artifact.icon_pin = `${this.icon_file_path}${this.iconNameMapping[shape]}_pin.png`;
    } else if (artifact.attributes['古墳現状'] === '消滅') {
      artifact.icon_min = `${this.icon_file_path}${this.iconNameMapping[shape]}-dis_min.png`;
      artifact.icon_pin = `${this.icon_file_path}${this.iconNameMapping[shape]}-dis_pin.png`;
    }
  }
  
  /**
   * ズームレベルによってマーカーラベルの表示・非表示を切り替える
   *
   */
  showMarkerLabelByZoomLevel (labelingZoomLevel, labelStyle) {
    const markers = this.map.getDisplayMarkers();
    const currentZoomLevel = this.map.getZoom();
    if (Object.keys(markers).length !== 0) {
      $.each(markers, (index, marker) => {
        if (currentZoomLevel < labelingZoomLevel) {
          labelStyle.text = '';
          this.map.setMarkerLabel(marker, labelStyle);
        } else if (currentZoomLevel >= labelingZoomLevel) {
          if (this.mapOptions.type === 'googlemap') {
            labelStyle.text = marker.name;
          } else if (this.mapOptions.type === 'openlayer') {
            labelStyle.text = marker.get('name');
          }
          this.map.setMarkerLabel(marker, labelStyle);
        }
      });
    }
  }
  
  /**
   * マーカーポップアップから対象の古墳の出土品・対象の展示施設の展示品を検索する
   * 検索メニューは対象の古墳・展示施設のみ選択した状態にする
   *
   * @param place
   * @param marker
   * @param popup
   */
  searchBySelectedMarker (place, marker, popup) {
    $('.mf-search-on-popup').off('click').on('click', event => {
      const type = $(popup).data('type');
      let facetValueName = '';
      if (type === 'kofun') {
        facetValueName = this.getKofunFacetValue(place);
        $('#page-feature').panel('open');
      } else if (type === 'museum') {
        facetValueName = marker.name;
        $('#page-search').panel('open');
      }
      const id = this.repository.getFacetValueIdsByName([facetValueName]);
      const $checkbox = $('[data-target="place-help-' + id + '"]').siblings('.js-facet-selector');

      this.forceChangeViewport('tile');
  
      // 検索メニュー更新: 主墳・陪塚検索初期化、対象の古墳・展示施設のみチェック、選択解除ボタン有効化
      this.controller.clearAllSelector();
      $checkbox.prop('checked', true);
      $checkbox.checkboxradio().checkboxradio('refresh');
      this.controller.toggleAllClearButton();
      
      // 対象の古墳の出土品・展示施設の展示品を検索
      this.searchTargetTypes = [];
      this.searchTargetTypes[id] = true;
      this.searchFromBaseMarker().then(() => {
        // ポップアップは開いたままにする
        this.map.setMarkerPopup(marker, popup);
      });
      
      return false;
    });
  }
  
  /**
   * 地図ビューに全古墳マーカーの表示がおさまらない場合は fitBounds を行う
   *
   * @param {Object} artifact
   */
  enableFitBounds (artifact) {
    if (
      this.map.getNorthEnd() < artifact.lat ||
      this.map.getEastEnd() < artifact.lng  ||
      this.map.getSouthEnd() > artifact.lat ||
      this.map.getWestEnd() > artifact.lng
    ) {
      this.fit_bounds = true;
    }
  }
  
  /**
   * @override
   * ?update=true: 古墳数・アイコンパスをconsole.log()で出力
   * 指定しない場合は通常の初期選択検索を行う
   *
   */
  firstAction () {
    const qs = this.getQueryString();
    
    // 百舌鳥エリア＋古市エリアによる検索: 全古墳数の取得
    if (qs.update) {
      const ids = this.repository.getFacetValueIdsByName(['百舌鳥エリア', '古市エリア', this.repositoryOptions.firstSelection]);
      this.searchTargetTypes[ids[0]] = true;
      this.searchTargetTypes[ids[1]] = true;
      this.searchTargetTypes[ids[2]] = false;
      this.disableSearchMenu();
      this.searchFromCenter();
      $('#page-search').panel('open');
    } else {
      super.firstAction()
      this.isInitEnd = true;
    }
    
    // 出土古墳検索 古墳数の更新（初期ロード時は data/ 以下の全古墳数ファイルから取得）
    $(this).on('ihAfterTransformPlacesResponse', (event, request, artifacts) => {
      $(this.controller).on('ihAfterUpdateFacetValue', () => {
        this.displayNumberOfKofun(artifacts, qs.update);
      });
    });
    $(this.map).on('ihDisplayedAllMarkers', (event, places, marker, popup) => {
      $('#ih-expanded-result-viewport').removeClass('ui-disabled');
      $('#page-feature').removeClass('ui-disabled');
      $('#page-search').removeClass('ui-disabled');
    });
  }
  
  disableSearchMenu () {
    $('.mf-af-search-by-kofun').addClass('ui-disabled');
    $('.js-search-type').addClass('ui-disabled');
  }
  
  /**
   * 特集パネル古墳検索の各ファセット値の古墳数を描画
   * ?update=true: 古墳アイコンパスをconsole.log()で出力
   *
   * @param {Array.<places>} artifacts
   * @param {Boolean} init
   */
  displayNumberOfKofun (artifacts, init = false) {
    let kofuns = [];
    let nums = {
      status: {
        '世界遺産': 0,
        '現存': 0,
        '消滅': 0
      },
      shape: {
        '前方後円墳': 0,
        '帆立貝形墳': 0,
        '円墳': 0,
        '方墳': 0,
        '形状不明': 0
      },
      length: {
        '200m以上': 0,
        '100m以上200m未満': 0,
        '50m以上100m未満': 0,
        '50m未満': 0,
        '不明': 0
      }
    };
  
    if (artifacts.length !== 0 && !this.keywordSearchMode) {
      artifacts.forEach( (artifact, index) => {
        const kofun = artifact.attributes['出土古墳'];
        const status = artifact.attributes['古墳現状'];
        const shape = artifact.attributes['出土古墳の墳形'];
        const length = artifact.attributes['出土古墳の墳丘長2'];
        if ( kofuns.indexOf(kofun) === -1 ) {
          kofuns[index] = kofun;
          nums.status[status]++;
          nums.shape[shape]++;
          nums.length[length]++;
          
          // 出土古墳ファセット値に古墳アイコンを描画（古墳数更新時の確認用）
          if (init) {
            const kofunName = this.getKofunFacetValue(artifact);
            if (status === '世界遺産') {
              if (shape === '前方後円墳' || shape === '帆立貝形墳') {
                this.kofunData[kofunName].icon = 'keyhole-wh_min';
              } else if (shape === '円墳') {
                this.kofunData[kofunName].icon = 'round-wh_min';
              } else if (shape === '方墳') {
                this.kofunData[kofunName].icon = 'square-wh_min';
              }
            } else if (status === '現存') {
              if (shape === '前方後円墳' || shape === '帆立貝形墳') {
                this.kofunData[kofunName].icon = 'keyhole_min';
              } else if (shape === '円墳') {
                this.kofunData[kofunName].icon = 'round_min';
              } else if (shape === '方墳') {
                this.kofunData[kofunName].icon = 'square_min';
              } else {
                this.kofunData[kofunName].icon = 'unknown_min';
              }
            } else if (status === '消滅') {
              if (shape === '前方後円墳' || shape === '帆立貝形墳') {
                this.kofunData[kofunName].icon = 'keyhole-dis_min';
              } else if (shape === '円墳') {
                this.kofunData[kofunName].icon = 'round-dis_min';
              } else if (shape === '方墳') {
                this.kofunData[kofunName].icon = 'square-dis_min';
              } else {
                this.kofunData[kofunName].icon = 'unknown-dis_min';
              }
            }
          }
        }
      });
    } else {
      nums = Object.assign({}, this.numberOfKofun);
    }
  
    $.each(nums, (index, item) => {
      $.each(item, (key, value) => {
        $('.js-tooltip:contains(' + key + ')').each(function () {
          const menu = $(this).find('.ui-btn-text');
          if (menu.find('.mf-af-search-by-kofun-name').text() === key) {
            menu.find('.js-facet-count').text('( ' + value + '基 )');
          }
        })
      });
    });
    
    if (init) {
      this.numberOfKofun = Object.assign({}, nums);
      console.log(this.numberOfKofun, this.kofunData)
    }
  }
  
  /**
   * 特集パネル 主墳・陪塚検索メニューの描画・検索処理
   *
   */
  renderMasterServantSearchMenu () {
    const $container = $('.mf-af-master-servant-search');
    let $lastValue = null;
    this.placeType.getAll().forEach( placeType => {
      // 「主墳」ファセットのファセット値を特集パネルに描画
      if (placeType.category.name === '主墳') {
        const attributes = _.find(placeType.category.items, function (item) {
          return item.id === placeType.id;
        });
        if (attributes.display == '1') {
          const $label = $('<label class="mf-af-master-servant-search-label"></label>');
          const $checkbox = $('<input type="checkbox" name="" value="" class="mf-af-master-servant-search-facet-value" />');
          $lastValue = $label;
          $label.append($checkbox);
          $label.append('<img class="mf-af-master-servant-search-icon" src="' + this.icon_file_path + this.kofunData[placeType.name].icon + '.png" />');
          $label.append(`<span class="mf-af-master-servant-search-name">${placeType.name}<span>（${this.kofunData[placeType.name].length}）</span></span>`);
          $container.append($label);
          $checkbox.data('id', placeType.id);
          $checkbox.checkboxradio();
          
          // 「主墳」ファセット値選択時の検索処理
          //   - 出土品検索・出土古墳検索・主墳検索による検索結果を全てクリア
          //   - 他の「主墳」ファセット値の選択を解除
          //   - 対象の「主墳」ファセット値のみで検索
          //   - 対象の「主墳」ファセット値以外は非表示（選択解除で表示）
          $checkbox.on('change', () => {
            const $facetValues = $('.mf-af-master-servant-search-facet-value');
            const checked = $checkbox.prop('checked');
            const cssClass = 'mf-af-master-servant-search-selected-facet-value';  // ファセット値表示の絞り込み時の下ボーダー表示用
            
            // 初期化
            this.controller.clearAllSelector();
            
            if (checked) {
              $label.addClass(cssClass);
              $facetValues.each((index, facetValue) => {
                $(facetValue).parent().hide();
              });
              $checkbox.parent().show();
              $checkbox.prop('checked', true).checkboxradio( 'refresh' );
              this.isMasterServantSearchMode = true;
              this.searchTargetTypes[placeType.id] = true;
              this.masterKofunAttributes.name = placeType.name;
            }
            
            this.searchFromBaseMarker();
          });
        }
      }
    });
    // 最後のメニューの下ボーダーラインを描画するためのCSSクラス付与
    $lastValue.addClass('mf-af-master-servant-search-last-facet-value');
  }
  
  /**
   * 主墳・陪塚検索の初期化
   *
   */
  initMasterServantSearchMenu () {
    const $facetValues = $('.mf-af-master-servant-search-facet-value');
    $facetValues.each((index, facetValue) => {
      $(facetValue).parent().show();
      $(facetValue).siblings('label').removeClass('mf-af-master-servant-search-selected-facet-value');
    });
  }
  
  /**
   * 選択状態によらず全ての出土古墳ファセット値を表示(開閉)可能にする
   *
   */
  showAllFindKofunFacetValues () {
    const facetId = 14;
    const $collapseMarker = $('#ih-collapsible-search-menu-marker-' + facetId);
    $collapseMarker.data('collapse', true);
    $collapseMarker.text('▲');
    $('.js-facet-selector').each((index, element) => {
      if ($(element).data('category') == facetId) {
        if ($(element).data('hide')) {
          $(element).data('hide', false);
        } else {
          $(element).prop('checked', true).checkboxradio( 'refresh' );
        }
      }
    });
    this.controller.toggleAllClearButton();
  }
  
  fitBoundsToMasterServantKofuns () {
    const latlng = this.map.createLatLng(this.masterKofunAttributes.lat, this.masterKofunAttributes.lng);
    this.map.setCenter(latlng);
    if (this.masterKofunAttributes.name === '仁徳天皇陵古墳' ||
        this.masterKofunAttributes.name === '応神天皇陵古墳' ||
        this.masterKofunAttributes.name === '履中天皇陵古墳') {
      this.map.setZoom(15);
    } else {
      this.map.setZoom(16);
    }
  }
  
  /**
   * 特定のファセットをデフォルト状態(閉じた状態)にする処理を統括管理
   * [条件] 初期化時、全選択解除時(※1)、対象ファセット閉状態で検索後に開状態になった時(※2)
   * ※1 全選択解除時は全てのファセットを閉じる（デフォルトでは開状態のファセットも含む）
   * ※2 通常検索では選択候補があるファセットは開状態になるため
   * 主墳・陪塚検索モードの場合は、先に同モード用の出土古墳ファセット値表示設定変更処理を行う
   *
   */
  controlCollapsibleFacets () {
    let wasCollapsed = [];
  
    $(this).on('ihBeforeRequestPlaces', (event, request, places) => {
      this.collapsedFacetIds.forEach(id => {
        wasCollapsed[id] = $('#ih-collapsible-search-menu-marker-' + id).data('collapse');
      });
    });
  
    $(this.controller).on('ihAfterUpdateFacetValue', () => {
      if (this.isMasterServantSearchMode) {
        this.showAllFindKofunFacetValues();
      }

      if (this.isAllSelectionCleared || this.keywordSearchMode) {
        $('.ih-collapsible-search-menu-marker').each((index, element) => {
          if ( !$(element).data('collapse') ) {
            const facetId = $(element).data('facetId');
            $(`.js-facility-category[data-category="${facetId}"]`).trigger('click');
          }
        });
        this.isAllSelectionCleared = false;
      } else {
        this.collapsedFacetIds.forEach(id => {
          const isCollapsed = $('#ih-collapsible-search-menu-marker-' + id).data('collapse');
          if (!isCollapsed && (this.isInitEnd || wasCollapsed[id])) {
            $('.js-facility-category[data-category="' + id + '"]').trigger('click');
          }
        });
        if (this.isInitEnd) {
          this.isInitEnd = false;
        }
      }
    });
  }
  
  setGoogleAnalytics () {
    if (this.isProduction) {
      $('.js-facet-selector').on("click", function (event) {
        const label = $(this).siblings('.js-tooltip').find('.ui-btn-text').find('span:not(.js-facet-count)').text();
        gtag('event', `検索メニュー`, {
          menu: label
        });
      });
      $("#page-place").on("panelopen", function () {
        const label = $(this).find('.iw-facet-1').text();
        gtag('event', `詳細パネル`, {
          menu: label
        });
      });
      $(".mf-map-selector").on("click", function (event) {
        const label = $(event.target).text().trim();
        if (label !== '') {
          gtag('event', '古代地形図');
        }
      });
    }
  }

  /**
   * 展示施設マーカー作成・描画
   * 
   * @param {Object} place 
   * @param {Object} marker 
   */
  createMuseumMarker (place, marker) {
    const museumName = place.attributes['展示施設'];
    if ( !this.displayedMuseumMarkers.includes(museumName) && museumData[museumName] ) {
      const museumPlace = this.createMuseumPlace(place, museumName);
      const marker = this.map.createMarker(museumPlace);
      const popup = this.createMuseumMarkerPopup(museumPlace, marker);
      this.displayedMuseumMarkers.push(museumName);
      this.createdMuseumPlaces[museumName] = museumPlace;
      this.map.gevent.addListener(marker, 'click', () => {
        this.map.mapEvents.emit('ihClickMarker', place, marker, popup);
      });
    }
  }

  /**
   * 
   * @param {Object} place 
   * @param {Object} museumName 
   * @returns {Text}
   */
  createMuseumPlace (place, museumName) {
    const museumPlace = Object.assign({}, place);
    museumPlace.name = museumPlace.id = museumName;
    museumPlace.address = museumData[museumName].address;
    museumPlace.lat = museumData[museumName].lat;
    museumPlace.lng = museumData[museumName].lng;
    museumPlace.icon_pin = '../sites/mozu-furu-artifact/assets/img/pin/museum_pin.png';
    return museumPlace;
  }

  /**
   * 展示施設マーカーポップアップ作成
   * 
   * @param {Object} place 
   * @param {Object} marker 
   * @returns {HTMLElement} 
   */
  createMuseumMarkerPopup (place, marker) {
    const templateClass = 'mf-af-iw-museum-template';
    const $popup = $(`.${templateClass}`).clone();
    $popup.removeClass(templateClass).addClass('info-window');
    $popup.find('.mf-af-iw-museum-name').text(place.name);
    $popup.find('.mf-af-iw-museum-address').text(place.address);
    $popup.data('place-id', place.name);
    $popup.data('place', place);
    $popup.data('type', 'museum');
    $popup.show();
    return $popup[0];
  }

  /**
   * マーカーポップアップ表示
   * 
   * @param {Object} marker 
   * @param {Object} popup 
   */
  openMarkerPopup (marker, popup) {
    this.map.closeMarkerPopup();
    this.map.setMarkerPopup(marker, popup);
    this.searchBySelectedMarker($(popup).data('place'), marker, popup);
  }

  /**
   * 展示施設マーカーポップアップ表示
   * 
   * @param {Object} place 
   * @param {String} facetValue 
   */
  openMuseumMarkerPopup (place, facetValue) {
    let museumPlace = {};
    if (this.createdMuseumPlaces[facetValue]) {
      museumPlace = this.createdMuseumPlaces[facetValue]
    } else {
      museumPlace = this.createMuseumPlace(place, facetValue);
    }
    const museumMarker = this.map.getPlaceMarker(museumPlace.id);
    const museumPopup = this.createMuseumMarkerPopup(museumPlace, museumMarker);
    this.openMarkerPopup(museumMarker, museumPopup);
  }

  /**
   * 古墳マーカーポップアップ表示
   * 
   * @param {Object} place 
   * @param {String} facetValue 
   */
  openKofunMarkerPopup (place, marker) {
    const markerPopup = this.popupFactory.build(place);
    this.openMarkerPopup(marker, markerPopup);
  }

  /**
   * 出土品を以下の順に並び替える
   * ・出土古墳の築造時期|出土古墳の墳丘長 > 出土品種別 > 出土古墳
   * 
   * @override
   * @param {Object} request 
   * @param {Object} response 
   * @returns 
   */
  transformPlacesResponse (request, response) {
    const key = this.repository.sortKey;
    const attr = this.repository.options.sortTarget[key];

    const sortByEra = artifact => {
      const value = artifact.attributes[attr];
      return this.repositoryOptions.sortValue.eras[value];
    };
    const sortByMound = artifact => {
      const value = artifact.attributes[attr].match(/\d+/);
      if (!value){
        return 1000;
      }
      return parseInt(value[0], 10) * -1;
    };
    const sortByArtifact = artifact => {
      const texts = artifact.attributes['出土品種別'].split(/\s>\s/);
      const facetValue = texts.length > 1 ? texts[1] : texts[0]; 
      return this.artifactOrder[facetValue];
    };
    const sortByKofun = artifact => {
      const facetValue = artifact.attributes['出土古墳'].split(/\s>\s/)[1];
      return this.kofunOrder[facetValue];
    };

    if (key === 'era') {
      response.places = _.sortBy(response.places, [sortByEra, sortByArtifact, sortByKofun]);
    } else if (key === 'mound') {
      response.places = _.sortBy(response.places, [sortByMound, sortByArtifact, sortByKofun]);
    }
    
    return super.transformPlacesResponse(request, response);
  }
};



// WEBPACK FOOTER //
// ./map/js/ih/extend/IHMozuFuruArtifact.js